define([
    "expose-loader?$!expose-loader?jQuery!jquery",
    "underscore",
    "backbone",
    "app",
    "local-router",
    "models/user",
    "components/header",
    "util/reporter",
    "i18next/i18next",
    "moment",
    "moment/es",
    "moment/pt-br",
    "backbone.overrides",
    "datetimepicker"
], function($, _, Backbone, App, Routers, UserModel, HeaderView, Reporter, i18n, moment) {
        "use strict";

        Reporter.init()
        App.init({
            user: new UserModel({
                html: $(".js-user")
            }, { parse: true }),
            router: new Routers[App.Constants.COUNTRY](),
        })
        _.each($(".js-app-flash"), function(flash) {
            var $alert = $(flash);
            App.Noti.show($alert.text(), $alert.attr("data-type"));
        });

        $("body").removeClass("is-loading no-js").addClass("js-loaded");

        // Header
        App.Header = new HeaderView();

        // ZenDesk
        if (typeof zE !== "undefined") {
            zE(function() {
                zE.setLocale("es");

                zE.identify({
                    name       : App.User.get("name"),
                    email      : App.User.get("email"),
                    externalId : App.User.get("id")
                });

            });

            $(".js-show-contact").click(function() {
                zE.activate();
            });
        }

        //i18n
        i18n.init({
            lng: App.Constants.LANGUAGE,
            resGetPath: "/legacy/locales/__ns__-__lng__.json",
            getAsync: true,
            fallbackLng: "es",
            useCookie: true,
            useLocalStorage: false,
            lowerCaseLng: true,
        });

        //Datetimepicker
        $.datetimepicker.setLocale(App.Constants.LANGUAGE_CODE);
        $.datetimepicker.setDateFormatter({
            parseDate: function (date, format) {
                var d = moment(date, format);
                return d.isValid() ? d.toDate() : false;
            },

            formatDate: function (date, format) {
                return moment(date).format(format);
            },
        });

        // Moment
        moment.locale(App.Constants.LANGUAGE);

        Backbone.history.start({
            hashChange: false,
            pushState: true,
            root: "/",
        });

        Backbone.$.ajaxSetup({
            headers: {
                "Accept-Language" : i18n.lng(),
                "Country" : App.Constants.COUNTRY,
            }
        });
    });
